import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CustomPipelineSelectOption } from './CustomPipelineSelectOption';
import { PipelineSelectButtonContent } from './PipelineSelectButtonContent';
import { getPipelineFilter } from '../../selectors/filtersSelectors';
import { FILTERS } from '../../constants/FiltersConstants';
import { getPipelines } from '../../selectors/forecastSelectors';
import { ALL_PIPELINES } from '../../constants/Pipelines';
import { setFilter } from '../../actions/FiltersActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PipelineFilter = ({
  selectType,
  isDealStageGrouping
}) => {
  var _useSelector;
  const dispatch = useDispatch();
  const pipelines = useSelector(getPipelines);
  const selectedPipelines = (_useSelector = useSelector(getPipelineFilter)) === null || _useSelector === void 0 ? void 0 : _useSelector.toArray();
  const pipelinesOptions = useMemo(() => {
    const updatedPipelineOptions = [];
    if (pipelines.size) {
      pipelines.forEach(pipeline => {
        updatedPipelineOptions.push({
          key: pipeline.get('pipelineId'),
          text: pipeline.get('label'),
          value: pipeline.get('pipelineId')
        });
      });
    }
    return updatedPipelineOptions;
  }, [pipelines]);
  const handlePipelineChange = useCallback(values => {
    void dispatch(setFilter({
      filter: FILTERS.PIPELINE,
      value: values.map(val => val.value)
    }));
  }, [dispatch]);
  const createPipelineOptions = useMemo(() => {
    var _options$;
    let options = pipelinesOptions;
    if (selectType === 'oneOrAll' && ((_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.value) !== ALL_PIPELINES) {
      options.unshift({
        text: I18n.text('analyze.pipelines.allPipelines'),
        key: ALL_PIPELINES,
        value: ALL_PIPELINES
      });
    }
    if (selectedPipelines.length === 1) {
      options = pipelinesOptions.map(option => option.value === selectedPipelines[0] ? Object.assign({}, option, {
        disabled: true,
        showTooltip: selectType === 'multi',
        tooltipPlacement: 'left',
        tooltipMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.filters.pipeline.atLeastOneSelected"
        })
      }) : option);
    }
    if (selectType === 'oneOrAll') {
      return options;
    }
    return [{
      selectAll: options.length > 1,
      showTooltip: isDealStageGrouping,
      tooltipMessage: I18n.text('repOverviewTable.filters.pipeline.viewAllPipelines'),
      tooltipPlacement: 'top left',
      text: I18n.text('repOverviewTable.filters.pipeline.all_text'),
      options
    }];
  }, [isDealStageGrouping, pipelinesOptions, selectType, selectedPipelines]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.pipeline.label"
    }), /*#__PURE__*/_jsx(UISelect, {
      multi: selectType === 'multi',
      searchable: false,
      "data-test-id": "pipeline-filter-select",
      "data-selenium-test": "rep-filter-pipeline",
      "aria-labelledby": "rep-filter-pipeline-label",
      buttonUse: "transparent",
      anchorType: "button"
      // eslint-disable-next-line hubspot-dev/no-inline-component-props
      ,
      ButtonContent: () => /*#__PURE__*/_jsx(PipelineSelectButtonContent, {
        isDealStageGrouping: isDealStageGrouping,
        pipelineFilterValues: selectedPipelines,
        pipelinesOptions: pipelinesOptions
      }),
      options: createPipelineOptions,
      optionComponent: CustomPipelineSelectOption,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.filters.pipeline.placeholder"
      }),
      onSelectedOptionChange: e => {
        if (Array.isArray(e.target.value) && !e.target.value.length) {
          handlePipelineChange([pipelinesOptions[0]]);
          return;
        }
        handlePipelineChange(Array.isArray(e.target.value) ? e.target.value : [e.target.value]);
      },
      value: selectType === 'multi' ? selectedPipelines : selectedPipelines[0],
      menuWidth: "auto",
      placement: "right bottom"
    })]
  });
};